export const NODE_NAME = 'toggle_block_content';
